import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import withMultiSelectState from "./multi_select_state";
import withResponsiveHeight from "./with_responsive_height";
import SourceList from "./source_list";
import DestinationList from "./destination_list";
import Loader from "./loader/loader";
import styles from "./multi_select.module.css";

const MultiSelect = (props) => {
  const {
    wrapperClassName,
    showSearch,
    height,
    itemHeight,
    selectedItemHeight,
    selectAllHeight,
    showSelectAll,
    showSelectedItems,
    itemRenderer,
    selectedItemRenderer,
    filteredItems,
    selectedItems,
    getList,
    filterItems,
    selectAllItems,
    isAllSelected,
    clearAll,
    selectItem,
    unselectItems,
    searchIcon,
    searchRenderer,
    selectAllRenderer,
    selectionStatusRenderer,
    noItemsRenderer,
    loaderRenderer,
    messages,
    loading,
    maxSelectedItems,
    searchValue,
    withGrouping,
    listRenderer,
    showSelectedItemsSearch,
    searchSelectedItemsValue,
    filterSelectedItems,
    filteredSelectedItems,
    isLocked
  } = props;

  const calculateHeight = () => {
    let calculatedHeight = height;
    if (showSearch && !maxSelectedItems) {
      calculatedHeight -= 45;
    }
    if (showSelectAll) {
      calculatedHeight -= (selectAllHeight || itemHeight);
    }
    return calculatedHeight;
  };

  const calculatedHeight = calculateHeight();
  const selectedIds = selectedItems.map(item => item.id);
  const disabled = maxSelectedItems && maxSelectedItems <= selectedItems.length;
  const LoaderRenderer = loaderRenderer;

  return (
    <div
      className={classnames(styles.wrapper, wrapperClassName)}
      style={{ height: height }}
    >
      {loading && <LoaderRenderer />}
      {!loading && (
        <SourceList
          id="source-list"
          searchValue={searchValue}
          searchRenderer={searchRenderer}
          showSearch={showSearch}
          selectAllRenderer={selectAllRenderer}
          filterItems={filterItems}
          searchIcon={searchIcon}
          messages={messages}
          showSelectAll={showSelectAll && !maxSelectedItems}
          itemHeight={itemHeight}
          selectAllItems={selectAllItems}
          isAllSelected={isAllSelected}
          selectedIds={selectedIds}
          itemRenderer={itemRenderer}
          getList={getList}
          filteredItems={filteredItems}
          calculatedHeight={calculatedHeight}
          selectItem={selectItem}
          noItemsRenderer={noItemsRenderer}
          disabled={disabled}
          selectAllHeight={selectAllHeight}
          withGrouping={withGrouping}
          listRenderer={listRenderer}
          isLocked={isLocked}
        />
      )}
      {!loading && showSelectedItems && (
        <DestinationList
          id="destination-list"
          selectionStatusRenderer={selectionStatusRenderer}
          selectedIds={selectedIds}
          clearAll={clearAll}
          messages={messages}
          itemHeight={selectedItemHeight || itemHeight}
          height={height}
          unselectItems={unselectItems}
          selectedItemRenderer={selectedItemRenderer}
          noItemsRenderer={noItemsRenderer}
          withGrouping={withGrouping}
          showSearch={showSelectedItemsSearch}
          searchValue={searchSelectedItemsValue}
          filteredItems={filteredSelectedItems}
          searchIcon={searchIcon}
          filterItems={filterSelectedItems}
          isLocked={isLocked}
        />
      )}
    </div>
  );
};

MultiSelect.propTypes = {
  selectedItems: PropTypes.array,
  filteredItems: PropTypes.array,
  loading: PropTypes.bool,
  messages: PropTypes.object,
  onChange: PropTypes.func,
  showSearch: PropTypes.bool,
  showSelectAll: PropTypes.bool,
  showSelectedItems: PropTypes.bool,
  searchIcon: PropTypes.string,
  deleteIcon: PropTypes.string,
  searchRenderer: PropTypes.func,
  selectedItemRenderer: PropTypes.func,
  height: PropTypes.number,
  itemHeight: PropTypes.number,
  selectedItemHeight: PropTypes.number,
  selectAllHeight: PropTypes.number,
  loaderRenderer: PropTypes.any,
  maxSelectedItems: PropTypes.number,
  withGrouping: PropTypes.bool,
  listRenderer: PropTypes.func,
  showSelectedItemsSearch: PropTypes.bool,
  isLocked: PropTypes.func
};

MultiSelect.defaultProps = {
  selectedItems: [],
  filteredItems: [],
  messages: {},
  showSearch: true,
  showSelectAll: true,
  showSelectedItems: true,
  height: 400,
  itemHeight: 40,
  loaderRenderer: Loader,
  withGrouping: false,
  showSelectedItemsSearch: false
};

export default withResponsiveHeight(withMultiSelectState(MultiSelect));